module.exports = [
  'Automotive Parts',
  'Sports',
  'Seasonal',
  'Decor',
  'Hardware'
];